// CGV KDMARCHE — texte officiel fourni par l'éditeur (10/09/2026)
// CG O'SCOP : voir ./cgu_mentions.js (CGU CommunityPlace officielles)

export const cgvKdmarcheContent = {
  id: "cgv-kdmarche",
  title: "Conditions Générales de Vente (CGV) – KDMARCHE",
  subtitle: "Marchandises — Gros et demi-gros — Marketplace CommunityPlace",
  version: "{{VERSION}}",
  dateEffet: "{{DATE_EFFET}}",
  reference: "CGV-KDM-2026-004",
  entity: "KDMARCHE",
  accentColor: "#D9B35A",
  sections: [
    {
      number: "1",
      title: "Champ d'application et Identification du Vendeur",
      content: `Les présentes Conditions Générales de Vente (CGV) s'appliquent de plein droit à toutes les ventes de marchandises conclues par le Vendeur :
- **Entrepreneure individuelle** : Félixia Vanessa PIPEROL
- **Nom commercial** : PRIMACOP INTERNATIONAL BUSINESS
- **Enseigne** : KDMARCHÉ
- **Forme juridique** : Entrepreneur individuel (EI)
- **SIREN** : 433 230 703
- **SIRET** : 433 230 703 00020
- **Adresse professionnelle** : Morne Bourg, chemin Symphart Lampecinado, 97170 Petit-Bourg, Guadeloupe (France)
- **Téléphone** : +590 690 90 64 29
- **Adresse e-mail de contact** : contact@primacop.com

Les présentes CGV régissent l'activité de vente de gros et demi-gros de KDMARCHÉ sur la marketplace accessible depuis le sous-domaine centrale.objectifscopoutremer.com (ci-après la « Plateforme »). Elles s'adressent aux acheteurs professionnels agissant pour les besoins de leur activité (ci-après « l'Acheteur »).`
    },
    {
      number: "2",
      title: "Produits, Prix structurels et Commandes",
      content: `- **Offres** : KDMARCHE propose un catalogue de produits de grande consommation (alimentaire, boissons, hygiène, bazar).
- **Prix mutualisés** : en tant que membre de l'écosystème coopératif des Outre-mer, l'Acheteur bénéficie de tarifs préférentiels dits « prix structurels mutualisés ». Les prix s'entendent Hors Taxes (HT) au départ ou franco de port selon l'Incoterm choisi lors de la validation. La TVA locale s'applique selon les taux en vigueur en Guadeloupe et dans les DROM.
- **Barème et réductions** : le prix HT affiché sur chaque offre constitue le barème applicable. Toute remise, ristourne ou réduction éventuelle est indiquée avant la validation de la commande.
- **Commandes** : toute commande n'est définitive qu'après validation électronique sur la Plateforme et émission du bon de commande.`
    },
    {
      number: "3",
      title: "Facturation et Modalités de paiement",
      content: `- **Émission de la facture** : conformément aux accords de la Plateforme, KDMARCHE émet directement la facture correspondant aux marchandises commandées. Aucun flux de paiement lié aux marchandises n'est collecté par l'opérateur technique O'SCOP.
- **Règlement** : le délai applicable est celui indiqué sur l'offre, le bon de commande et la facture. À défaut de stipulation particulière, le prix est payable au trentième jour suivant la réception des marchandises.
- **Retard de paiement** : toute somme non payée à l'échéance produit, de plein droit et sans rappel, des pénalités au taux de refinancement de la Banque centrale européenne majoré de dix points, sans pouvoir être inférieur à trois fois le taux d'intérêt légal.
- **Indemnité de recouvrement** : une indemnité forfaitaire de 40 € est due de plein droit pour frais de recouvrement, sans préjudice d'une indemnisation complémentaire sur justificatifs.
- **Escompte** : aucun escompte n'est accordé pour paiement anticipé, sauf accord écrit contraire.
- **Moyens de paiement** : les moyens proposés sont affichés avant la validation de la commande ; le prestataire de paiement effectivement utilisé est identifié dans le parcours de paiement.`
    },
    {
      number: "4",
      title: "Livraison et Réception des marchandises",
      content: `- **Incoterms et Transport** : les conditions de livraison varient selon les options du catalogue (EXW, FOB, CIF, DAP ou DDP).
- **Transfert des risques** : le transfert des risques s'effectue au moment de la remise des marchandises selon l'Incoterm retenu. L'Acheteur Pro est tenu de vérifier la conformité des produits (quantité, état des palettes/colis) dès la réception et de formuler toute réserve caractérisée de manière électronique ou sur le bon de livraison.`
    },
    {
      number: "5",
      title: "Exclusion du droit de rétractation (Transactions B2B)",
      content: `Les ventes conclues entre professionnels pour les besoins de leur activité n'ouvrent en principe aucun droit de rétractation. Toutefois, les dispositions impératives de l'article L. 221-3 du Code de la consommation demeurent applicables lorsqu'un professionnel emploie au plus cinq salariés, que le contrat est conclu hors établissement et que son objet n'entre pas dans le champ de son activité principale. Les retours restent possibles dans les cas prévus par la loi et en cas de non-conformité ou de vice caché.`
    },
    {
      number: "6",
      title: "Clause de réserve de propriété",
      highlight: true,
      content: `PRIMACOP INTERNATIONAL BUSINESS, enseigne KDMARCHÉ, conserve la propriété exclusive des marchandises vendues jusqu'au paiement intégral de leur prix en principal et accessoires. À défaut de paiement à l'échéance, le Vendeur se réserve le droit de revendiquer et de reprendre les marchandises aux frais et risques de l'Acheteur, sous réserve des règles impératives applicables.`
    },
    {
      number: "7",
      title: "Propriété intellectuelle",
      content: `L'utilisation de la marque KDMARCHÉ, de ses logos, de ses fiches techniques ou de ses photographies de produits sur des canaux externes est interdite sans l'accord écrit préalable de PRIMACOP INTERNATIONAL BUSINESS, sous réserve des exceptions prévues par la loi.`
    },
    {
      number: "8",
      title: "Droit applicable et Attribution de juridiction",
      content: `Les présentes CGV sont soumises à la loi française. En cas de contestation ou de litige commercial entre professionnels portant sur l'exécution des commandes, la facturation ou la livraison, et à défaut de résolution amiable, compétence exclusive est attribuée au Tribunal de Commerce de Pointe-à-Pitre.`
    }
  ]
};
